<template>
  <v-dialog v-model="dialog" width="1200">
    <!-- <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" color="purple" small
        ><v-icon>mdi-chart-line</v-icon></v-btn
      >
    </template> -->
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        <v-row align="center" class="">
          <v-col cols="2"> Andamento </v-col>
          <v-col cols="4">
            <v-select
              v-model="intervallo_sel"
              label="intervallo"
              hide-details
              outlined
              clear-icon=""
              dense
              :items="intervalli"
              item-value="value"
              item-text="text"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="granularita_sel"
              label="granularità"
              hide-details
              outlined
              clear-icon=""
              dense
              :items="granularita"
              item-value="value"
              item-text="text"
            ></v-select>
          </v-col>
        </v-row>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">chiudi</v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-if="loading" fill-height align="center" justify="center"
          ><v-progress-circular
            indeterminate
            color="green"
          ></v-progress-circular
        ></v-row>
        <v-row v-else>
          <v-col cols="12" class="mt-2">
            <VueApexCharts
              class="mt-n2"
              type="area"
              :options="options"
              :series="series"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    VueApexCharts,
  },
  props: {
    tank: Object,
  },
  data() {
    return {
      dialog: false,
      loading: true,
      char_data: [],
      intervalli: [
        { text: "1 giorno", value: 24 },
        { text: "2 giorni", value: 48 },
        { text: "3 giorni", value: 72 },
        { text: "7 giorni", value: 168 },
        { text: "15 giorni", value: 360 },
      ],
      intervallo_sel: 24,
      granularita: [
        { text: "10 minuti", value: 600 },
        { text: "30 minuti", value: 1800 },
        { text: "1 ora", value: 3600 },
        { text: "3 ore", value: 10800 },
        { text: "6 ore", value: 21600 },
        { text: "12 ore", value: 43200 },
        { text: "24 ore", value: 86400 },
      ],
      granularita_sel: 3600,
      options: {
        chart: {
          zoom: {
            enabled: false,
          },
          sparkline: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            show: true,
          },
          axisBorder: {
            show: true,
          },
          axisTicks: {
            show: true,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: [
          {
            min: 0,
            max: this.tank.volume_totale,
            tickAmount: 20,
            labels: {
              show: true,
            },
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: true,
            },
          },
          {
            opposite: true,
            min: -10,
            max: 30,
            tickAmount: 20,
            labels: {
              show: true,
            },
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: true,
            },
          },
          {
            opposite: true,
            min: 0,
            max: 500,
            tickAmount: 20,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: true,
            },
          },
        ],
        // colors: ["#448AFF", "#00E676"],
        stroke: {
          curve: ["smooth", "smooth", "smooth"],
          width: [2, 1],
          //colors: ["#3F51B5", "#FF5722", "#00E676"],
        },
        fill: {
          type: ["gradient"],
          colors: ["#1A73E8", "#FF9800"],
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.8,
            opacityTo: 0.1,
            stops: [0, 100],
          },
        },
      },
    };
  },
  mounted() {},
  watch: {
    intervallo_sel: function () {
      //this.loading = true;
      this.$store
        .dispatch("fetch_tank_chart_data", {
          id_tank: this.tank.id,
          ts_inizio: moment()
            .subtract(this.intervallo_sel, "hours")
            .format("X"),
          ts_fine: moment().format("X"),
        })
        .then((res) => {
          this.char_data = res;
          //this.loading = false;
        });
    },
  },
  computed: {
    series() {
      // Raggruppa i dati in base alla granularità temporale selezionata
      const gruppi = this.char_data.reduce((acc, curr) => {
        const gruppoKey = Math.floor(curr.timestamp / this.granularita_sel);
        
        if (!acc[gruppoKey]) {
          acc[gruppoKey] = {
            timestamp: gruppoKey * this.granularita_sel * 1000,
            litri: [],
            temperature: [],
            raw: [],
          };
        }
        
        acc[gruppoKey].litri.push(curr.value);
        acc[gruppoKey].temperature.push(curr.temperatura);
        acc[gruppoKey].raw.push(curr.lettura_raw);
        
        return acc;
      }, {});

      // Funzione helper per calcolare la media
      const calcolaMedia = (values) => {
        if (!values || values.length === 0) return 0;
        const sum = values.reduce((acc, val) => acc + val, 0);
        return (sum / values.length).toFixed(1);
      };

      // Converti i gruppi in array e calcola le medie
      const gruppiArray = Object.values(gruppi);

      return [
        {
          type: "area",
          name: "Litri",
          data: gruppiArray.map((gruppo) => [
            gruppo.timestamp,
            calcolaMedia(gruppo.litri),
          ]),
        },
        {
          type: "line",
          name: "Gradi",
          data: gruppiArray.map((gruppo) => [
            gruppo.timestamp,
            calcolaMedia(gruppo.temperature),
          ]),
        },
        {
          type: "line",
          name: "Raw",
          data: gruppiArray.map((gruppo) => [
            gruppo.timestamp,
            calcolaMedia(gruppo.raw),
          ]),
        },
      ];
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.loading = true;
      this.$store
        .dispatch("fetch_tank_chart_data", {
          id_tank: this.tank.id,
          ts_inizio: moment()
            .subtract(this.intervallo_sel, "hours")
            .format("X"),
          ts_fine: moment().format("X"),
        })
        .then((res) => {
          this.char_data = res;
          this.loading = false;
          
        });
    },
  },
};
</script>